import './CuratorHeader.css';
import React from 'react';
import { get, getGlobalDictionaryTerm, getPageThemeColors, canUseDOM, getColorByTheme } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';

//ressources
import { ReactComponent as IconTwitter } from '../../resources/icons/twitter.svg';
import { ReactComponent as IconInsta } from '../../resources/icons/InstagramBlue.svg';
import { ReactComponent as IconFacebook } from '../../resources/icons/facebook.svg';
import { ReactComponent as IconYoutube } from '../../resources/icons/youtube.svg';
import { ReactComponent as IconLinkedin } from '../../resources/icons/linkedin.svg';
import { Text, RichText, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
const videoWhiteOverlayTime = 750;
const videoFadeTime = 400;
export const CuratorHeader = _ref => {
  let {
    fields,
    rendering,
    children,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  const isSharedCh = get(params, 'RenderingStyle') === 'Shared Channels' || false;
  const introText = get(fields, 'data.item.introText.jss');
  const curatorName = get(fields, 'data.item.curatorName.jss') || {};
  const name = get(fields, 'data.item.name');
  const facebookHREF = get(fields, 'data.item.facebook.jss.value', '');
  const instaHREF = get(fields, 'data.item.instagram.jss.value', '');
  const twitterHREF = get(fields, 'data.item.twitter.jss.value', '');
  const youtubeHREF = get(fields, 'data.item.youtube.jss.value', '');
  const linkedinHREF = get(fields, 'data.item.linkedIn.jss.value', '');
  const curatorRole = get(fields, 'data.item.curatorRole.jss');
  const {
    socialAnalytics
  } = fields.data;
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const ColorHex = get(params, 'ColorHex');
  const variables = BackgroundColorHex ? {
    '--m57-curator-header-primary-color': BackgroundColorHex,
    '--m57-curator-header-active-primary-color': ActiveColorHex,
    '--m57-curator-header-color': ColorHex
  } : {
    '--m57-curator-header-primary-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--m57-curator-header-active-primary-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m57-curator-header-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  const renderMediaPlaceholder = () => {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "media-header-general",
      rendering: rendering
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    isSharedCh: isSharedCh
  }, /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    "data-animation-breakpoint": "768",
    className: "header-animation-breakpoint header__poi header__full-width-mob js-header-bm-parent"
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder(), /*#__PURE__*/React.createElement("div", {
    className: "header-bb__info js-header-bm header-animation__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: `header-animate__content-bg`
  }), /*#__PURE__*/React.createElement("div", {
    className: "header__type-tag"
  }, /*#__PURE__*/React.createElement(Text, {
    field: curatorRole
  })), curatorName.value ? /*#__PURE__*/React.createElement("h1", {
    className: "header__info-title"
  }, /*#__PURE__*/React.createElement(Text, {
    field: curatorName
  })) : '', (facebookHREF || instaHREF || twitterHREF || youtubeHREF || linkedinHREF) && /*#__PURE__*/React.createElement("div", {
    className: "header__icons"
  }, facebookHREF && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: facebookHREF,
    rel: "noopener noreferrer",
    title: `Facebook: ${curatorName.value} | ${newWindowLabel}`,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), `Facebook : ${name}`)
  }, /*#__PURE__*/React.createElement(IconFacebook, {
    className: "details-icon__img"
  })), instaHREF && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: instaHREF,
    rel: "noopener noreferrer",
    title: `Instagram: ${curatorName.value} | ${newWindowLabel}`,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), `Instagram : ${name}`)
  }, /*#__PURE__*/React.createElement(IconInsta, {
    className: "details-icon__img"
  })), twitterHREF && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: twitterHREF,
    rel: "noopener noreferrer",
    title: `Twitter: ${curatorName.value} | ${newWindowLabel}`,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), `Twitter : ${name}`)
  }, /*#__PURE__*/React.createElement(IconTwitter, {
    className: "details-icon__img"
  })), youtubeHREF && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: youtubeHREF,
    rel: "noopener noreferrer",
    title: `Youtube: ${curatorName.value} | ${newWindowLabel}`,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), `Youtube : ${name}`)
  }, /*#__PURE__*/React.createElement(IconYoutube, {
    className: "details-icon__img"
  })), linkedinHREF && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: linkedinHREF,
    rel: "noopener noreferrer",
    title: `Linkedin: ${curatorName.value} | ${newWindowLabel}`,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), `Linkedin : ${name}`)
  }, /*#__PURE__*/React.createElement(IconLinkedin, {
    className: "details-icon__img"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "header__content-p"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: introText
  })))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter,
    isSharedCh
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `header-animation   ${isSharedCh ? 'shared-styles' : ''}  ${commonStyle}  ${fullWidthStyles}  ${rtl ? rtlStyles : ltrStyles} ${headerImageStyle}`
  }, children);
};
const commonStyle = "c10pwjl7";
const ltrStyles = "l1l6wt9c";
const rtlStyles = "r17pw6z8";
export default CuratorHeader;